export default __webpack_public_path__ + "static/ranklists-unsuccessful-a7edd6a42031e3e119d8a1b68133f73f.gif";